import { render, staticRenderFns } from "./DeliveryStatus.vue?vue&type=template&id=516c1d18&scoped=true&"
import script from "./DeliveryStatus.vue?vue&type=script&lang=js&"
export * from "./DeliveryStatus.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryStatus.vue?vue&type=style&index=0&id=516c1d18&lang=sass&scoped=true&"
import style1 from "./DeliveryStatus.vue?vue&type=style&index=1&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "516c1d18",
  null
  
)

export default component.exports